const newestArticlesAjax = {
  offset: 0,
  postsPerPage: 2,
  submitButton: null,
  container: null,
  loader: null,

  init() {
    this.postsPerPage = document.querySelector('.newest-articles__posts').children.length;
    this.container = document.querySelector('.newest-articles__posts');
    this.loader = document.querySelector('.loader-container');
		this.alreadyAppearedPostIds = JSON.parse(document.querySelector('.newest-articles').getAttribute('data-already-appeared-post-ids'));

    this.submitButton = document.querySelector('.newest-articles__load-more');
    this.submitButton?.addEventListener('click', () => this.submit());
  },

  submit() {
    this.offset += this.postsPerPage;

    const data = new FormData();
    data.append('action', 'newest-articles');
    data.append('offset', this.offset);
    data.append('posts_per_page', this.postsPerPage);
		data.append('already_appeared_post_ids', JSON.stringify(this.alreadyAppearedPostIds));

    this.loader.classList.add('active');

    fetch(ajax.ajax_url, {
      method: 'POST',
      body: data,
    })
      .then((res) => res.json())
      .then((data) => {
        const response = data.data;
        const { html, hasMore } = response;

        this.container.insertAdjacentHTML('beforeend', html);
        if (!hasMore) {
          this.submitButton.classList.add('newest-articles__load-more--hidden');
        }

        this.loader.classList.remove('active');
      })
      .catch((err) => {
        console.error(err);
      });
  },
};

document.addEventListener('DOMContentLoaded', () => {
  newestArticlesAjax.init();
});
